
export const EARLY_BIRD_DISCOUNT_CUTOFF = new Date('1800/05/31'); // THIS DEFAULTS TO 00:00:00. Make sure to set the time too OR set it to the next day
export const DEFAULT_SESSION_GROUP = 'NO_GROUP';
export const ASMHomePage = "https://www.bct2026.org/";

//package id constants
export const TRAINEE_AND_EARLY_CAREER_EVENT_PACKAGE_ONLY = 17;

// Session ID constants
export const CAP_MEETING_SESSION_ID = 1;
export const ABSTRACT_VIEWING_SESSION_ID = 7;
export const FACULTY_DINNER_SESSION_ID = 9;
export const CONFERENCE_DINNER_SESSION_ID = 15;

//form definition id constants
export const REGISTRATION_FORM_DEFINITION_ID = 1;
export const EARLY_BIRD_FORM_DEFINITION_ID = 10;

//step index constants
export const REGISTRATION_TYPE_STEP_INDEX = 1;
export const PACKAGE_STEP_INDEX = 2;
export const REGISTRATION_INFO_STEP_INDEX = 3;

//registration type constants
export const REGISTRATION_TYPE_DEFAULT = 1;
export const REGISTRATION_TYPE_STUDENT = 2;
export const REGISTRATION_TYPE_TRIAL_COORDINATOR = 3;
export const REGISTRATION_TYPE_REGISTRAR = 4;
export const REGISTRATION_TYPE_STAFF = 5;
export const REGISTRATION_TYPE_ATTENDEE_FROM_JAPAN_OR_KOREA = 6;
export const NEXT_YEAR_EARLY_REGISTRATION_TYPE = 8;

//attendance type constants
export const ATTENDANCE_TYPE_IN_PERSON = 1;